import React from 'react'
import { DisclaimerMessage } from './DisclaimerMessage'

export default {
  commission: null,
  disclaimer: (isF2F) => <DisclaimerMessage isF2F={isF2F} />,
  disclaimerOnline: (isF2F) => <DisclaimerMessage isF2F={isF2F} />,
}
